import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Drawer } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getParamValue } from "../../../utils";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router";
import _ from "lodash";
import CategoryLayout from "../Layout";
import AddCategory from "../AddCategory";

import CategoryHeader from "../Layout/topHeader";
import { useDispatch } from "react-redux";
import { SET_CATEGORY_INFO } from "../../../redux/auth/authType";

const GlobalCategoryDetails = (): ReactElement => {
  const [singleCategoryInfo, setSingleCategoryInfo] = useState({
    loading: false,
    data: null,
  });
  const [selectedCategoryForEdit, setSelectedCategoryForEdit] =
    useState(undefined);
  const [visible, setVisible] = useState(false);
  const route = useParams();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const dispatch = useDispatch();

  const fetchCategoryDetails = useCallback(() => {
    setSingleCategoryInfo({ loading: true, data: undefined });
    axios
      .get(
        `${
          process.env.REACT_APP_CATALOG_READER_API
        }/admin/category/detail?categoryId=${(route as any).categoryId}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((data) => {
        if (data.status === 200) {
          setSingleCategoryInfo({
            loading: false,
            data: data?.data?.category,
          });
          dispatch({
            type: SET_CATEGORY_INFO,
            payload: {
              categoryInfo: {
                id: data?.data?.category?.id,
                title: data?.data?.category?.title,
                slug: data?.data?.category?.slug,
                type: data?.data?.category?.type,
                image: data?.data?.category?.image,
                bannerImage: data?.data?.category?.bannerImage,
              },
            },
          });
        } else {
          setSingleCategoryInfo({ loading: false, data: null });
          responseNotification(
            data.statusText || "something went wrong",
            "error"
          );
        }
      })
      .catch((err) => {
        setSingleCategoryInfo({ loading: false, data: null });

        console.log(err);
      });
  }, []);

  useEffect(() => {
    fetchCategoryDetails();
  }, [fetchCategoryDetails]);

  useEffect(() => {
    if (visible) {
      setSelectedCategoryForEdit(undefined);
    }
  }, [selectedCategoryForEdit]);

  useEffect(() => {
    setSelectedCategoryForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedCategoryForEdit(null);
    fetchCategoryDetails();
  };

  const category = singleCategoryInfo?.data;

  return (
    <React.Fragment>
      <CategoryLayout categoryId={(route as any)?.categoryId as string}>
        <div className="bg-white">
          <CategoryHeader
            leftarea={"Category Details"}
            rightarea={
              <Button
                type="primary"
                onClick={() => {
                  setSelectedCategoryForEdit(singleCategoryInfo.data?.id);
                }}
                danger
              >
                <EditOutlined /> Edit
              </Button>
            }
          />
          <div className="details-area">
            <div className="pt-4">
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Category Name</span>
                  <span className="info-desc">{category?.title}</span>
                </div>

                <div className="single">
                  <span className="info-name">Slug</span>
                  <span className="info-desc">{category?.slug}</span>
                </div>

                <div className="single">
                  <span className="info-name">ID</span>
                  <span className="info-desc">{category?.id}</span>
                </div>

                <div className="single">
                  <span className="info-name">Type</span>
                  <span className="info-desc">
                    {category?.type?.replace("_", " ")}
                  </span>
                </div>

                {category?.position && (
                  <div className="single">
                    <span className="info-name">Position</span>
                    <span className="info-desc">{category?.position}</span>
                  </div>
                )}

                {category?.level && (
                  <div className="single">
                    <span className="info-name">Level</span>
                    <span className="info-desc">{category?.level}</span>
                  </div>
                )}

                {category?.parent && (
                  <div className="single">
                    <span className="info-name">Parent ID</span>
                    <span className="info-desc">{category?.parent}</span>
                  </div>
                )}

                {category?.description && (
                  <div className="single">
                    <span className="info-name">Description</span>
                    <span className="info-desc">{category?.description}</span>
                  </div>
                )}

                <div className="single">
                  <span className="info-name">Status</span>
                  <div className="info-desc">
                    <span
                      className={`radius-btn text-uppercase ${
                        category?.deleted === true ? "inacive" : "active"
                      }-btn`}
                    >
                      {category?.deleted === true ? (
                        <>
                          <CloseOutlined className="mr-1" /> Deleted
                        </>
                      ) : (
                        <>
                          <CheckOutlined className="mr-1" /> Active{" "}
                        </>
                      )}
                      {category?.status?.split("_").join(" ")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Drawer
            title={selectedCategoryForEdit ? "Edit Category" : ""}
            width={600}
            onClose={() => {
              setSelectedCategoryForEdit(null);
            }}
            visible={selectedCategoryForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedCategoryForEdit ? (
              <AddCategory
                visibleData={selectedCategoryForEdit}
                onCloseMethod={onClose}
              />
            ) : undefined}
          </Drawer>
        </div>
      </CategoryLayout>
    </React.Fragment>
  );
};
GlobalCategoryDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default GlobalCategoryDetails;
